const SET_FUND = (state, payload) => {
  state.fund = { ...payload }
}

const RESET_STATE = (state) => {
  state.fund = JSON.parse(JSON.stringify(state.initialFund))
}

const SET_ERRORS = (state, payload) => {
  state.errors = { ...payload }
}

const RESET_ERRORS = (state) => {
  state.errors = { ...state.initialErrors }
}

const UPDATE_VALUES = (state, payload) => {
  Object.assign(state.fund, payload)
}

const SET_LIST = (state, payload) => {
  state.list = payload
}

const RESET_LIST = (state) => {
  state.list = []
}

export default {
  SET_FUND,
  RESET_STATE,
  SET_ERRORS,
  RESET_ERRORS,
  UPDATE_VALUES,
  SET_LIST,
  RESET_LIST
}



// WEBPACK FOOTER //
// ./src/features/funds/store/mutations.js